import React from "react";
import { ICON_NAMES, LucideIcon } from "./icon-registry";

interface Props { value: string | null; color: string; onChange: (name: string) => void; }

export default function IconPicker({ value, color, onChange }: Props) {
    return (
        <div className="m-iconpicker-grid">
            {ICON_NAMES.map(n => (
                <button
                    type="button" key={n}
                    className={`m-iconpicker-tile${n === value ? " active" : ""}`}
                    style={{ background: n === value ? color : "#f1f5f9", color: n === value ? "#fff" : color }}
                    onClick={() => onChange(n)}
                    title={n}
                >
                    <LucideIcon name={n} size={18} />
                </button>
            ))}
        </div>
    );
}
